import React, { FC, useMemo } from 'react'
import { ExpandableRow } from 'transfix-ui/components/ExpandableRow'
import { Box } from 'transfix-ui/core'
import { IShipmentIssueStates } from 'types/graphqlTypes'
import { IShipmentIssueDetailsFragment } from '../graphql/ShipmentIssueDetailsFragment'
import IssueDetails from './IssueDetails'
import IssueRow from './IssueRow'

interface IssueRowsProps {
  /**
   * @default []
   */
  issues: IShipmentIssueDetailsFragment[]
  shipmentId: string
  activeIssue: string | null
  /**
   * Flag to show the reduced version of this component.
   * @example When the right-side panel is open, it will have fewer fields than usually does
   * @default false
   */
  reducedVersion?: boolean
  readOnly?: boolean
}

export const IssueRows: FC<IssueRowsProps> = ({
  issues = [],
  shipmentId,
  activeIssue,
  reducedVersion = false,
  readOnly = false,
}) => {
  const issuesSorted = useMemo(() => {
    const resolvedIssues = issues.filter(issue => issue.state === IShipmentIssueStates.resolved)
    const nonResolvedIssues = issues.filter(issue => issue.state !== IShipmentIssueStates.resolved)

    return [...nonResolvedIssues, ...resolvedIssues]
  }, [issues])

  return (
    <Box data-test='issue-expandable-rows' width='100%' margin='auto' px={2} pb={1}>
      {issuesSorted.map(issue => (
        <ExpandableRow
          key={issue.id}
          row={<IssueRow issue={issue} reducedVersion={reducedVersion} />}
          expanded={issue.id === activeIssue}
          details={<IssueDetails issue={issue} shipmentId={shipmentId} readOnly={readOnly} />}
        />
      ))}
    </Box>
  )
}

export default IssueRows
